import React, { ReactNode, useEffect, useRef } from "react";
import st from "@/styles/Ui.module.scss";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import clsx from "clsx";

interface AccordionProps {
    icon?: ReactNode;
    children: ReactNode;
    label: string;
    open: boolean;
    onClick(): void;
    no_chevrone?: boolean
}

const Accordion: React.FC<AccordionProps> = React.memo((props) => {
    const {
        icon,
        children,
        label,
        open,
        onClick ,
        no_chevrone
    } = props;
    
    const ref = useRef<HTMLDivElement>(null);
    // const [firstChildHeight, setFirstChildHeight] = useState<number>(0);
    const loaded = useRef(false)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    // useEffect(() => {
    //     if (ref.current && ref.current.firstChild) {
    //         const firstChild = ref.current.firstChild as HTMLElement;
    //         setFirstChildHeight(firstChild.offsetHeight);
    //     }
    // }, [open, children]);
    
    useEffect(() => {
        
        if(!loaded.current) {
            const setTransition = () => {
                const timeout = setTimeout(() => {
                    if(debug === "true") console.info("setInterval Accordion")
                    
                    if(ref.current) {
                        ref.current.classList.add(st.has_transition)
                    }
                    
                    clearTimeout(timeout)
                }, 1000)
            }
            
            setTransition()
        }
        
        return () => {
            loaded.current = true
        }
        
    }, []);
    
    return (
        <div className={clsx(st.accordion, open && st.a_open)}>
            <div onClick={onClick} className={clsx(st.header, open && st.h_open)}>
                <div className={clsx(st.left, st.sides)}>
                    {icon}
                    {label}
                </div>
                
                {!no_chevrone && (
                    <div className={clsx(st.right, st.sides)}>
                        <ChevroneIcon />
                    </div>
                )}
            </div>
            
            <div
                ref={ref}
                style={{
                    // height: open ? `${firstChildHeight}px` : "0",
                    overflow: "hidden",
                }}
                className={clsx(st.body, open && st.open)}
            >
                {children}
            </div>
        </div>
    );
});

export default Accordion;
